var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-6 pl-2"},[(_vm.device.type==='paybox')?_c('GP4AM_parameters',{attrs:{"device":_vm.device}}):_vm._e(),(_vm.device.type==='gp4bc')?_c('GP4BC_parameters',{attrs:{"device":_vm.device}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }